import styled, { css } from 'styled-components'
import { NectarHeading } from '../../../../helpers/StyledWrappers.styles'

const aspectRatioAsPercentage = (ratio) => {
  const [w, h] = String(ratio).split(':')
  const ratioPercentage = (h / w) * 100
  return `${ratioPercentage.toFixed(2)}%`
}

const setPosition = (position) => css`
  text-align: ${position === 'center' ? 'center' : 'left'};
`

export const StyledContainer = styled.div`
  margin-bottom: ${(props) => `${props.theme.size.spacing.lg}`};
`

export const StyledHeading = styled.h1`
  ${(props) => setPosition(props.alignment)}
  ${NectarHeading}
  && {
    /* We need increased specificity here to override the bolt typography styles */
    margin-bottom: ${(props) => `${props.theme.size.spacing.lg}`};
  }
`

export const StyledImageWrapper = styled.div`
  display: block;
  position: relative;
  margin-bottom: ${(props) => `${props.theme.size.spacing.lg}`};

  &::after {
    display: block;
    content: '';

    /* Use padding-bottom to fix the aspect-ratio on images */
    @media only screen and (max-width: ${(props) => props.breakpoint}) {
      padding-bottom: ${aspectRatioAsPercentage('4:3')};
    }
    ${(props) => {
      switch (props.mediaRatio) {
        case 'tall':
          return css`
            padding-bottom: ${aspectRatioAsPercentage('21:9')};
          `
        case 'short':
        default:
          return css`
            padding-bottom: ${aspectRatioAsPercentage('10:3')};
          `
      }
    }}
  }

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

export const StyledCopy = styled.p`
  ${(props) => setPosition(props.alignment)}

  && {
    /* We need increased specificity here to override the bolt typography styles */
    margin-bottom: ${(props) => `${props.theme.size.spacing.lg}`};
  }
`

export const StyledGridWrapper = styled.div`
  /* Hide the overflow from the exterior borders being used to simulate gaps */
  overflow: hidden;
  display: block;
`

export const StyledGrid = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: ${(props) => (props.alignment === 'center' ? 'center' : 'flex-start')};
  gap: ${(props) => props.theme.size.spacing.lg};

  /* Grid item specific styles for children */
  > * {
    /* Clip the background to the padding box, rather than outside, to avoid it spilling into the borders */
    background-clip: padding-box;
    /* 21% here is used to ensure that at minimum four items are presented on a row */
    flex: 1 0 21%;
    @media screen and (max-width: ${(props) => `${props.breakpoint}`}) {
      /* On smaller screens, only show two items (40%) in a row */
      flex: 1 0 40%;
    }

    /* Needed to override the margins on M032 CTA */
    > * {
      margin-bottom: 0;
      height: 100%;

      /* Hack to center button content in the M032 CTA */
      > * {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    &:only-child {
      /* 230px from the designs for a single CTA. */
      max-width: 230px;
    }
  }
`
